/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceAlertsMapping extends models.FreshserviceMappingBase {
    getFixupPrototypeFunction() { return FreshserviceAlertsMapping.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceAlertsMapping>): FreshserviceAlertsMapping {
        let obj = Object.assign(new FreshserviceAlertsMapping(), model);
        FreshserviceAlertsMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceAlertsMapping>): FreshserviceAlertsMapping {
        if (!model) return null;
        return FreshserviceAlertsMapping.newInstance(<FreshserviceAlertsMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceAlertsMapping) {
        if (!obj) return;

        models.FreshserviceAlertsMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceAlertsMapping): boolean {
        if (models.FreshserviceMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FreshserviceAlertsMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.attribute_mappings) {
            for (let val of this.attribute_mappings) {
                models.FreshserviceIncidentConfigurationMappingForAlerts.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Alert attribute enums for Freshservice
     */
    description_attributes: Array<models.DescriptionAttributeForItsmAlert>;

    /**
     * List of Freshservice attribute mappings
     */
    attribute_mappings: Array<models.FreshserviceIncidentConfigurationMappingForAlerts>;

}
